module.exports = __webpack_public_path__ + "static/media/logo.58931952.svg";